import { Button, IconButton, IconButtonProps } from '@chakra-ui/react';
import { FC } from 'react';
import { ArrowDown } from '../icons';

interface ControlButtonProps {
  showNavigation: boolean;
  onClick: () => void;
  type: 'prev' | 'next';
  size?: IconButtonProps['size'];
  disabled?: boolean;
}

const ControlButton: FC<ControlButtonProps> = ({
  onClick,
  showNavigation,
  type,
  size = 'sm',
  disabled,
}) => {
  const icon = type === 'prev' ? <ArrowDown boxSize={6} /> : <ArrowDown boxSize={6} />;

  const handleClick: IconButtonProps['onClick'] = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Button
      _disabled={{ opacity: showNavigation ? 0.5 : 0 }}
      _hover={{ bgColor: 'transparent' }}
      height='100%'
      isDisabled={disabled}
      left={type === 'prev' ? 0 : 'auto'}
      opacity={showNavigation ? 1 : 0}
      position='absolute'
      right={type === 'next' ? 0 : 'auto'}
      top='50%'
      transform='translateY(-50%)'
      transition='ease-in-out 0.3s'
      variant='ghost'
      w='20%'
      zIndex={1}
      onClick={handleClick}
    >
      <IconButton
        _hover={{ bgColor: 'bg.light' }}
        aria-label={type === 'prev' ? 'Previous Slide' : 'Next Slide'}
        as='span'
        bgColor='gray.light'
        colorScheme='gray'
        icon={icon}
        isDisabled={disabled}
        isRound
        size={size}
        transform={type === 'prev' ? 'rotate(90deg)' : 'rotate(-90deg)'}
        variant='outline'
      />
    </Button>
  );
};

export default ControlButton;
